<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace" id="epi"> </p>
<p class="ep">The medical and psychological research protocols and procedures mentioned in this book are real.</p>
<p class="half-space"> </p>
<p class="ep">The use of the electric shocking collar is based on its actual and increasing use in all fields of dog training.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epi.vue?b59a5f24